/*
 * @Descripttion: 
 * @Version: 0.0.1
 * @Author: zhaozheng
 * @Date: 2021-10-11 16:38:49
 * @LastEditors: zhaozheng
 * @LastEditTime: 2022-12-07 17:47:59
 */
import R from './Axios';
let BaseUrl = '';
let BaseUrl2 = '';
let sendMessageUrl = ''; // todo 上线前进行替换 

/** 生产环境*/
BaseUrl = 'https://recruit-api.hndt.com/client';
BaseUrl2 = 'https://recruit-api.hndt.com';

// sendMessageUrl = 'https://message.dianzhenkeji.com/sendmsg/shortMessage/sendMessage'
sendMessageUrl = 'https://gw.hntv.tv/sms/send'

// 预发布

// BaseUrl = 'https://pre-recruit-api.hndt.com/client';
// BaseUrl2 = 'https://pre-recruit-api.hndt.com';
// sendMessageUrl =
//   'https://message.test.dianzhenkeji.com/sendmsg/shortMessage/sendMessage';

//获取简历
const resumes = () => R.get(`${BaseUrl}/user/resumes`);
//文件上传
const upload = (data) => R.post(`${BaseUrl}/file/upload`, data);
//更新报名信息
const apply = (data) => R.post(`${BaseUrl}/user/apply`, data);
//添加或修改个人信息
const info = (data) => R.post(`${BaseUrl}/user/info`, data);
//添加或修改工作经验
const work = (data) => R.post(`${BaseUrl}/user/work`, data);
//添加或修改个人特长
const specialty = (data) => R.post(`${BaseUrl}/user/specialty`, data);
//添加或修改资质证书
const creden = (data) => R.post(`${BaseUrl}/user/creden`, data);
//添加或修改教育经历
const education = (data) => R.post(`${BaseUrl}/user/education`, data);
//保存简历
const push = () => R.post(`${BaseUrl}/user/save/push`);
//获取限定时间
const limitTime = () => R.get(`${BaseUrl}/conf/limitTime`);
//全部岗位
const stationIdList = () => R.get(`${BaseUrl}/station/list`);
//删除资质证书
const deleteCredenId = (credenId) =>
  R.delete(`${BaseUrl}/user/creden?credenId=${credenId}`);
//删除工作经验
const deleteWorkId = (workId) =>
  R.delete(`${BaseUrl}/user/work?workId=${workId}`);

//全部单位
const allPart = () => R.get(`${BaseUrl}/unit/list`);
//单位详情
const partDetail = (id) => R.get(`${BaseUrl}/unit/detail?unitId=${id}`);
//全部职位
const allJob = (id) =>
  R.get(`${BaseUrl}/station/index/list${id ? '?unitId=' + id : ''}`);
//职位详情
const jobDetail = (id) => R.get(`${BaseUrl}/station/detail?stationId=${id}`);
//查看是否有简历
const isHave = () => R.get(`${BaseUrl}/apply/ensure`);
//投递简历
const sureJob = (data) => R.post(`${BaseUrl}/apply`, data);
//查看结果
const viewResults = () => R.get(`${BaseUrl}/apply/result`);
//获取服务器时间
const getTimestamp = () => R.get(`https://gw.hntv.tv/sms/public/currentTime`);
//短信发送
const sendMessage = (data) => R.post(sendMessageUrl, data);
// 登陆
const logins = (mobile, code) =>
  R.post(`${BaseUrl2}/sms/login`, { mobile, verifyCode: code });

//公告列表
const allNotice = (data) => R.get(`${BaseUrl}/notice/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}`);

// 全部岗位类别
const allStationCategory = () =>
  R.get(`${BaseUrl2}/system/dict/data/type/recruit_station_category`);

// 学校列表
const schoolList = (data = { "scName": "" }) => R.post(`${BaseUrl}/education/schools`, data);
// 专业列表
const majorList = (data) => R.post(`${BaseUrl}/education/majors`, data);

export {
  jobDetail,
  resumes,
  upload,
  apply,
  info,
  work,
  specialty,
  creden,
  education,
  push,
  limitTime,
  allPart,
  stationIdList,
  sendMessage,
  getTimestamp,
  logins,
  partDetail,
  allJob,
  isHave,
  viewResults,
  sureJob,
  deleteCredenId,
  deleteWorkId,
  allNotice,
  allStationCategory,
  schoolList,
  majorList
};



// WEBPACK FOOTER //
// ./src/module/api.js